import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { Container, Divider, Stack } from '@mui/material';

import Button from 'components/Common/Button';
import Tab from 'components/Common/Tab';
import routes from 'constants/routes';
import ParishonerUserDetailContainer from 'components/Community/ParishonerUserDetailContainer';
import ParishonerProfileContainer from 'components/Community/ParishonerProfileContainer';
import ParishionerActivityContainer from 'components/Community/ParishionerActivityContainer';
import { getFullName } from 'utils/helpers';

function ParishonerDetail() {
    const navigate = useNavigate();
    const [tab, setTab] = useState('userdetails');
    const { details } = useSelector((state: RootState) => state.community.parishionerDetails);
    const { username, imgUrl } = details || {};

    const setTabValue = (value: string) => {
        setTab(value);
    };

    const handleSendInvoice = () => {
        navigate(routes.sendinvoice.main, { state: { username } });
    };

    return (
        <Stack direction={{ xs: 'column', lg: 'row' }}>
            <div>
                <Container>
                    <ParishonerProfileContainer imgUrl={imgUrl} title={getFullName(details)} subtitle={username} />
                </Container>

                <div style={{ display: 'flex', justifyContent: 'center', marginTop: 12, marginBottom: 20 }}>
                    <Button onClick={handleSendInvoice} width={'23rem'} title={'Send Invoice'} />
                </div>
            </div>
            <Container sx={{ backgroundColor: 'white', p: 1, mx: 2 }}>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        paddingLeft: 6,
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                    }}
                >
                    <Tab
                        tabs={[
                            { value: 'userdetails', label: 'User details' },
                            { value: 'activity', label: 'Activity' },
                        ]}
                        tabValue={tab}
                        setTabValue={setTabValue}
                    />
                </div>
                <Divider light={true} />

                <Stack>{tab !== 'userdetails' ? <ParishionerActivityContainer /> : <ParishonerUserDetailContainer />}</Stack>
            </Container>
        </Stack>
    );
}

export default ParishonerDetail;
